import { boxPlanningKeys } from "@/modules/boxPlanning/gateway/boxPlanningKeys"
import { boxSlotKeys } from "@/modules/boxSlot/gateway/boxSlotKeys"
import { boxSlotSessionKeys } from "@/modules/boxSlotSession/gateway/boxSlotSessionKey"
import { useServicesContext } from "@/modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useBoxSlotDeleteSession() {
  const { boxSlotSessionApi } = useServicesContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ sessionId }: { sessionId: string }) => {
      await boxSlotSessionApi.deleteSession(sessionId)
    },
    onSuccess: async (_, { sessionId }) => {
      queryClient.removeQueries({ queryKey: boxSlotSessionKeys.session(sessionId) })
      await queryClient.invalidateQueries({
        queryKey: boxSlotSessionKeys.all,
      })
      await queryClient.invalidateQueries({
        queryKey: boxSlotKeys.all,
      })
      await queryClient.invalidateQueries({ queryKey: boxPlanningKeys.slots() })
    },
  })
}
